import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './centered-block.scss';

const COMPONENT_NAME = 'centered-block';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Centered Block)
 */
export class CenteredBlock {
  constructor() {
    const self = this;

    this._els = {
      centeredBlock: $(`.${BEM.BLOCK}`),
    };

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.centeredBlock.each(function () {
        const $instanceEl = $(this);
        TextColorCheck._checkBackground($instanceEl);
      });
    });
  }
}
